"use client";

import type { Checkout } from "@repo/core/checkout";
import type { ReactNode, RefObject } from "react";
import { createContext } from "react";

import type { MarketAwareSlug } from "@/utils/const";

import type {
  CheckoutEurobonusBlock,
  CheckoutMadeToOrderBlock,
} from "../types";

export type CheckoutContextProps = {
  details: MarketAwareSlug;
  initialCheckout?: Checkout | null;
  madeToOrderBlock?: CheckoutMadeToOrderBlock;
  eurobonusBlock?: CheckoutEurobonusBlock;
  deliveryStepRef?: RefObject<HTMLFormElement | null>;
  paymentStepRef?: RefObject<HTMLDivElement | null>;
  adyenDropInRef?: RefObject<HTMLDivElement | null>;
  walleyWidgetRef?: RefObject<HTMLDivElement | null>;
};

export type CheckoutProviderProps = CheckoutContextProps & {
  children: ReactNode;
};

export const CheckoutContext = createContext<CheckoutContextProps | undefined>(
  undefined,
);
